import React, { useState, Fragment } from 'react';
import { Field } from 'formik';
import './form-elements.scss';

export default ({
  name,
  forwardedRef,
  clickHandler,
  acceptFiles,
  attachOption,
  errorMsg,
  setField = true,
  capture = false,
  file,
  updateFile = () => {},
}) => {
  const handleChange = (e, setFieldValue, setFieldError) => {
    e.preventDefault();

    const fileTypes = acceptFiles.split(',');
    let files = e.target.files;
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      let reader = new FileReader();
      if (file && fileTypes.includes(file.type)) {
        if (file.type !== 'application/msword') {
          reader.onloadend = () => {
            updateFile(file);
          };
          reader.readAsDataURL(file);
          clickHandler(file);
          if (!attachOption) setFieldValue(name, null);
          if (setField) setFieldValue(name, file);
          setFieldError(name, null);
        } else {
          setFieldError(name, errorMsg);
          clickHandler(null);
        }
      } else {
        setFieldError(name, errorMsg);
        clickHandler(null);
      }
    }
  };

  return (
    <Field name={name}>
      {({ form, meta }) => (
        <Fragment>
          <div
            className={`file-input-wrapper ${
              meta.touched && meta.error ? 'error' : ''
            }`}
          >
            <label className="custom-file-input-wrapper">
              Choose File
              <input
                id={name}
                ref={forwardedRef}
                type="file"
                className="custom-file-input"
                accept={acceptFiles}
                multiple={attachOption}
                onClick={e => (e.target.value = '')}
                onChange={e => {
                  handleChange(e, form.setFieldValue, form.setFieldError);
                }}
                aria-label="file"
                capture={capture}
              />
            </label>
            {setField && (
              <label className="uploadPhoto" htmlFor="file">
                {file ? file.name : 'No file chosen'}
              </label>
            )}
          </div>
          {meta.error && meta.touched && (
            <p className="error-message">{meta.error}</p>
          )}
        </Fragment>
      )}
    </Field>
  );
};
